<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="text-search-cont">
    <v-autocomplete
        @change="changeValue"
        v-model="tags"
        :disabled="isUpdating"
        :items="getTags"
        chips
        label="태그로 장르 검색하기"
        multiple
        prepend-icon="search"
    >
      <template v-slot:selection="data">
        <v-chip
            :selected="data.selected"
            close
            class="chip--select-multi"
            @input="remove(data.item)"
        >
          #{{ data.item }}
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
  export default {
    props: {
      genreList: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        tags: null,
        isUpdating: false
      }
    },
    computed: {
      getTags () {
        let tags = [];
        for (let i of this.genreList) {
          let extracts = i['genre-ko'].split(' ');
          tags = tags.concat(extracts);
        }
        tags = this.uniq(tags);
        tags.splice(tags.indexOf('&'), 1);
        tags.splice(tags.indexOf('Show'), 1);
        tags.splice(tags.indexOf('영화'), 1);
        return tags;
      }
    },
    methods: {
      changeValue () {
        this.$emit('changeValue', this.tags);
      },
      uniq (arrays) {
        return arrays.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      },
      remove (item) {
        const index = this.tags.indexOf(item);
        if (index >= 0) this.tags.splice(index, 1);
        this.changeValue();
      }
    },
  }
</script>

<style scoped>
.text-search-cont {
  width: 100%;
}
</style>